import { createFileRoute } from '@tanstack/react-router'

import { PlatformSlipPage } from '../../../../components/pages/backoffice/platform/slips/platform-slip-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/organizations/$organizationTechnicalName/slips')({
  component: function Component() {
    const { organizationTechnicalName } = Route.useParams()

    return (
      <PermissionChecker requiredPermissions={['slip.read']}>
        <PlatformSlipPage organizationTechnicalName={organizationTechnicalName} />
      </PermissionChecker>
    )
  },
})
